import urlParse from 'url-parse'

/* eslint-disable no-unused-vars */
import { downloadBlob } from '@/services/utils/modules/download'

import request from '../../request'
import {
  getUrlDataCommaStrToArr,
  transitionDownUrlObj,
} from '@/services/utils/modules/base'
import { ASYNC_EXPORT_COLUMN_TYPE_ENUM } from '@/services/enums'

/**
 * 异步生成 导出任务 需要修复参数
 * 处理 countryCode countryCodeList shopId shopIdList
 * @param {*} reqData
 * @returns
 */
function fixReqDataOnCreateAsyncExportTask(reqData = {}) {
  const ret = {
    ...reqData
  }

  const { queryData = {} } = reqData
  const { countryCode, countryCodeList, shopId, shopIdList } = queryData
  if (countryCode) {
    ret.countryCode = countryCode
    delete ret.queryData.countryCode
  }
  if (countryCodeList) {
    ret.countryCodeList = countryCodeList
    delete ret.queryData.countryCodeList
  }
  if (shopId) {
    ret.shopId = shopId
    delete ret.queryData.shopId
  }
  if (shopIdList) {
    ret.shopIdList = shopIdList
    delete ret.queryData.shopIdList
  }

  return ret
}

export default {
  async fetchDownloadDemo(data = {}, options = {}, filename = '文件') {
    const res = await request(
      {
        url: '/xxx/xxx',
        method: 'post',
        responseType: 'blob', // important, request对axios 二次封装，注意参数书写位置
        desc: '下载模板',
      },
      {
        ...data,
      },
      options
    )

    downloadBlob(res, filename)

    return true
  },
  /**
   * 通用post下载，使用者自己提供url，和参数
   * @param {*} urlPath 下载的url
   * @param {*} data 数据
   * @param {*} options Ajax options
   * @param {*} filename 文件名称
   * @returns
   */
  async fetchDownloadPostGeneric(
    urlPath,
    data = {},
    options = {},
    filename = undefined
  ) {
    const res = await request(
      {
        url: urlPath,
        method: 'post',
        responseType: 'blob', // important, request对axios 二次封装，注意参数书写位置
        desc: '下载模板',
      },
      {
        ...data,
      },
      {
        ...options,
        // 获取完整的ajax返回
        customGetFullRes: true,
      }
    )

    // 从header里面获取文件名称
    const serverFileNameMatched =
      res.headers['content-disposition'] &&
      res.headers['content-disposition'].match(/filename=(.*)/)
    const serverFileName =
      serverFileNameMatched && serverFileNameMatched.length >= 2
        ? decodeURIComponent(serverFileNameMatched[1])
        : ''
    // 最终文件名称
    const finalFilename = filename || serverFileName || '文件'

    downloadBlob(res.data, finalFilename)

    return true
  },
  async fetchDownloadGetGeneric(
    urlPath,
    data = {},
    options = {},
    filename = undefined
  ) {
    const res = await request(
      {
        url: urlPath,
        method: 'get',
        responseType: 'blob', // important, request对axios 二次封装，注意参数书写位置
        desc: '下载模板',
      },
      {
        ...data,
      },
      {
        ...options,
        // 获取完整的ajax返回
        customGetFullRes: true,
      }
    )

    // 从header里面获取文件名称
    const serverFileNameMatched =
      res.headers['content-disposition'] &&
      res.headers['content-disposition'].match(/filename=(.*)/)
    const serverFileName =
      serverFileNameMatched && serverFileNameMatched.length >= 2
        ? decodeURIComponent(serverFileNameMatched[1])
        : ''
    // 最终文件名称
    const finalFilename = filename || serverFileName || '文件'

    downloadBlob(res.data, finalFilename)

    return true
  },
  /**
   * 下载任务列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchListAsyncExportPage(data = {}, options = {}) {
    return request(
      {
        url: '/asyncExport/page',
        method: 'post',
        desc: '下载模板',
      },
      {
        ...data,
      },
      {
        ...options,
      }
    )
  },
  /**
   * 创建异步下载任务
   * @param {*} exportCode 任务代码
   * @param {*} exportColumnType 任务类型 csv excel
   * @param {*} queryData 查询参数
   * @param {*} data 额外参数
   * @param {*} options
   * @returns
   */
  async fetchCreateAsyncDownloadTask(
    exportCode,
    exportColumnType = ASYNC_EXPORT_COLUMN_TYPE_ENUM.csv,
    queryData = {},
    data = {},
    options = {}
  ) {
    if (!exportCode) {
      console.error('请提供下载code exportCode')
      return
    }

    const queryDataFianl = {
      ...queryData
    }

    const reqData = fixReqDataOnCreateAsyncExportTask({
      ...data,
      exportCode,
      exportColumnType,
      queryData,
    })

    return request(
      {
        url: '/asyncExport/createDownloadTask',
        method: 'post',
        desc: '创建异步下载任务',
      },
      reqData,
      {
        ...options,
      }
    )
  },
  // get 方式的下载 -> post下载
  async fetchDownloadGetToPost(url) {
    const urlObj = urlParse(url)
    const pathname = urlObj.pathname.slice(4)
    const qsObj = getUrlDataCommaStrToArr(url)

    await this.fetchDownloadPostGeneric(pathname, qsObj)
  },
  /**
   * 异步导出-获取进度
   * @param {*} data {exportIdList: []}
   * @param {*} options
   * @returns
   */
  async fetchPercentageAsyncExport(exportIdList, data = {}, options = {}) {
    return request(
      {
        url: '/asyncExport/getExportProgress',
        method: 'post',
        desc: '异步导出-获取进度',
      },
      {
        exportIdList,
        ...data,
      },
      {
        ...options,
      }
    )
  },
}
